module.exports = __webpack_public_path__ + "static/media/02n.fb7567a1.png";